import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import { useOnboardingContext } from '../../Contexts/OnboardingContext';

import OnboardingHasUserContentRouter from './OnboardingHasUserContentRouter';
import OnboardingNoAccess from '../../Pages/OnboardingNoAccess';

const OnboardingHasUserContentPicker = () => {
  const { householdResource } = useOnboardingContext();

  return pickFunction(householdResource, {
    [fr.relationships.hasDigitalOnboarding.name]: () => {
      return (
        <OnboardingHasUserContentRouter />
      );
    },
    [fr.relationships.default.name]: () => {
      return (
        <OnboardingNoAccess />
      );
    },
  });
};

export default OnboardingHasUserContentPicker;
